// 分页模型
class PagingModel {
  // 页码
  public page: number;
  // 每页数据条数
  public rows: number;

  constructor() {
    this.page = 1;
    this.rows = 20;
  }
}

export default PagingModel;
